import { useCallback, useEffect, useState } from "react";
import { Drawer, Flex, Segmented, Space, Spin, Tag, Typography, Button, Alert } from "antd";
import { RedoOutlined, BellOutlined } from "@ant-design/icons";
import { getCurrentDateTime, getFormattedDateWithDay } from "../utils/datesUtils";
import { CLEANS_STATUSES, DrawerType } from "../config/types";
import { Logout } from "./Logout";
import { InstructionBlock } from "./Drawers/InstructionBlock";
import { Calendar } from "./Calendar/Calendar";
import { useStore } from "../config/store";
import { CleanBlock } from "./Drawers/CleanBlock";
import { CodeBlock } from "./Drawers/CodeBlock";
import { CommentBlock } from "./Drawers/CommentBlock";
import { BuyBlock } from "./Drawers/BuyBlock";
import { FixBlock } from "./Drawers/FixBlock";
import { FinishBlock } from "./Drawers/FinishBlock";
import { Theory } from "./Theory";
import { HowinBlock } from "./Drawers/HowinBlock";
import { categoryToAccusative, isTelegramWebApp, isTelegramWebView, openExternalLink } from "../utils";
import { RefuseBlock } from "./Drawers/RefuseBlock";
import { MetersBlock } from "./Drawers/MetersBlock";
import InstallButton from "./InstallButton";
import { isNotificationPermissionGranted, notificationService } from "../notification-service";
import { UploadFinishFilesBlock } from "./Drawers/UploadFinishFilesBlock";
import { Card } from "./Card";

const DRAWERS: Record<DrawerType, any> = {
  clean: <CleanBlock />,
  code: <CodeBlock />,
  instruction: <InstructionBlock />,
  comment: <CommentBlock />,
  buy: <BuyBlock />,
  fix: <FixBlock />,
  finish: <FinishBlock />,
  upload: <UploadFinishFilesBlock />,
  theory: <Theory />,
  howin: <Theory />,
  refuse: <RefuseBlock />,
  meters: <MetersBlock />,
};

enum FilterValueEnum {
  ACTIVE = "active",
  DONE = "done",
}

export const Cleans = () => {
  const [cal, setCal] = useState(false);
  const [activeFilter, setActiveFilter] = useState<FilterValueEnum>(FilterValueEnum.ACTIVE);
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());

  const { drawer, clean, cleans, done_cleans, getSettings, getCleans, setDrawer, closeDrawer, getDoneCleans } =
    useStore();

  const handleRefresh = useCallback((activeFilterValue: FilterValueEnum) => {
    setCurrentDateTime(getCurrentDateTime());
    getSettings();
    if (activeFilterValue === FilterValueEnum.DONE) {
      getDoneCleans();
    } else {
      getCleans();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleRefresh(activeFilter)
  }, [activeFilter, handleRefresh]);

  const cleaner_id = localStorage.getItem("cleaner_id");

  if (!cleans) return <Spin />;

  // const isTodayClean = cur?.date === getTodayDate() ? true : false;

  return (
    <div>
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Flex justify="center" align="center" vertical gap="10px">
          <Typography.Text style={{color: '#d3d3d3'}}>
            {currentDateTime}
          </Typography.Text>
          { !isTelegramWebApp() && !isTelegramWebView() && <InstallButton />}
          { !isTelegramWebApp() && !isTelegramWebView() && !isNotificationPermissionGranted() && <Button type="primary" icon={<BellOutlined />}
                   onClick={() => notificationService.requestNotificationPermission()}>Включить уведомления</Button>}
          { isTelegramWebView() && <Alert message="Сайт открыт через телеграмм. Откройте приложение в браузере." type="info" showIcon /> }
        </Flex>
        <Flex justify="space-between" align="center" style={{ padding: "15px 0" }}>
          <div className="link" onClick={() => setDrawer("theory")}>
            Помощь
          </div>
          <RedoOutlined style={{ fontSize: "18px", color: "#1677ff" }} onClick={() => handleRefresh(activeFilter)} />
          <div className="link" onClick={() => setCal(!cal)}>
            Календарь
          </div>
        </Flex>
        {cal && <Calendar events={cleans} />}
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Segmented
            onChange={setActiveFilter}
            options={[
              { label: "Предстоящие", value: FilterValueEnum.ACTIVE },
              { label: "Выполненные", value: FilterValueEnum.DONE },
            ]}
          />
          {activeFilter === FilterValueEnum.ACTIVE
            ? cleans.length > 0
              ? cleans.map((item) => (
                  <Card key={item.id} onClick={() => setDrawer("clean", item)}>
                    <Space direction="vertical">
                      <div className="bold">{getFormattedDateWithDay(item.date)}</div>
                      <Space>
                        <span>{item.plan_time || item.cleantime}</span>
                        {item.rent?.has_out && <Tag>выехали</Tag>}
                        {item.rentAfter && <span className="red">заезд</span>}
                      </Space>
                      {/* <div>{item.object.address}</div> */}
                      <div>{item.object.name}</div>
                      {item.comment && item.comment.length > 0 && <div className="red">Есть комментарий!</div>}
                      <Space size="small">
                        <Tag color={CLEANS_STATUSES[item.status].color}>{CLEANS_STATUSES[item.status].label}</Tag>
                        {item.type !== "Простая" && <Tag>{item.type}</Tag>}
                        {item.rate && <Tag color="green">{`оценка ${item.rate}`}</Tag>}
                        {!item.cleaner_id && <Tag>не назначена</Tag>}
                        {!['finish' , 'refusal'].includes(item.status) && item.object && item.object.meters_requested && <Tag color="magenta">нужно внести счетчики</Tag>}
                      </Space>
                      {/* <div>{item.cost}</div> */}
                    </Space>
                  </Card>
                ))
              : "Нет ближайших уборок"
            : null}
          {activeFilter === FilterValueEnum.DONE
            ? done_cleans.length > 0
              ? done_cleans.map((item: any) => (
                  <Card key={item.id} onClick={() => setDrawer("clean", item)}>
                    <Space direction="vertical">
                      <div className="bold">{getFormattedDateWithDay(item.date)}</div>
                      <div>{item.object.name}</div>
                      {/* {item.comment && item.comment.length > 0 && <div className="red">Есть комментарий!</div>} */}
                      <Space>
                        {item.type !== "Простая" && <Tag>{item.type}</Tag>}
                        <div>{item.cost} р.</div>
                        {item.rate && <Tag color="green">{`оценка ${item.rate}`}</Tag>}
                      </Space>
                    </Space>
                  </Card>
                ))
              : "Нет выполненных уборок"
            : null}

          <Flex justify="space-between" align="center" style={{marginTop: '50px'}} gap="12px">
            <Logout />
            {cleaner_id && (
              <Typography.Text
                style={{flexShrink: 1, color: '#d3d3d3'}}
                ellipsis={{ tooltip: cleaner_id, expanded: false, defaultExpanded: false }}
              >
                ID: {cleaner_id}
              </Typography.Text>
            )}
          </Flex>
        </Space>
      </Space>
      {drawer === "theory" && (
        <Drawer title="Инструкция" onClose={closeDrawer} open={!!drawer}>
          <Theory />
        </Drawer>
      )}
      {drawer === "howin" && (
        <Drawer title={`Как попасть в ${categoryToAccusative(clean?.object.category)}`} onClose={closeDrawer} open={!!drawer}>
          <HowinBlock />
        </Drawer>
      )}
      <Drawer title="Уборка" onClose={closeDrawer} open={!!drawer} width={800} className={String(drawer)}>
        {drawer && clean && DRAWERS[drawer]}
      </Drawer>
    </div>
  );
};
